// extracted by mini-css-extract-plugin
export default {"ActionWrapper":"DataTable_ActionWrapper__NfcWJ","lastRow":"DataTable_lastRow__N-6sx"};